import { render } from "./DashboardStackedBarChart.vue?vue&type=template&id=139e8d5e&scoped=true"
import script from "./DashboardStackedBarChart.vue?vue&type=script&lang=js"
export * from "./DashboardStackedBarChart.vue?vue&type=script&lang=js"

import "./DashboardStackedBarChart.vue?vue&type=style&index=0&id=139e8d5e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-139e8d5e"]])

export default __exports__